<template>
  <div class="procedureBox">
    <div class="procedureMain">
      <breadcrumb>
        <el-breadcrumb slot="breadcrumb" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path:'/personal/serviceHome' }">公证服务</el-breadcrumb-item>
          <el-breadcrumb-item>公证进度</el-breadcrumb-item>
        </el-breadcrumb>
      </breadcrumb>
      <wait-reject v-if="status==0"></wait-reject>
      <wait-sub v-if="status==1"></wait-sub>
      <wait-audit v-if="status==2"></wait-audit>
      <wait-pay v-if="status==3"></wait-pay>
      <wait-accreditation v-if="status==4"></wait-accreditation>
      <finshed v-if="status==5"></finshed>
    </div>
  </div>
</template>
<script>
import Dialog from "@common/Dialog.vue";
import BaseApi from "@lib/baseApi.js";
import waitPay from "./schedule/waitPay.vue";
import waitSub from "./schedule/waitSubmit.vue";
import waitAudit from "./schedule/waitAudit.vue";
import waitAccreditation from "./schedule/waitAccreditation.vue";
import finshed from "./schedule/finshed.vue";
import waitReject from "./schedule/waitReject.vue";
import breadcrumb from "@common/Breadcrumb.vue";

export default {
  data() {
    return {
      fileNum: false,
      dialogVisible: false,
      successFul: false,
      money: "",
      id: "",
      returnList: {},
      notaryId: "",
      status: "",
      resultData: [],
      ruleForm: {
        num: "",
        mail: "",
        photo: "",
        registeredHome: "",
        currentHome: "",
        resultData: "",
        proxyName: "",
        proxyCard: ""
      },
      rules: {
        mail: [
          { required: true, message: "*请输入邮箱", trigger: "blur" },
          {
            pattern: /^[A-Za-z0-9_-\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: "*邮箱格式错误，请重新输入",
            trigger: "blur"
          }
        ],
        photo: [
          { required: true, message: "*请输入手机号", trigger: "blur" },
          {
            pattern: /^((13[0-9])|(15[0-9])|(14[^4,\\D])|(16[0-9])|(17[0-9])|(18[0-9])||(19[8,9]))\d{8}$/,
            message: "*手机号格式错误，请重新输入",
            trigger: "blur"
          }
        ],
        registeredHome: [
          { required: true, message: "*请输入户口所在地", trigger: "blur" }
        ],
        currentHome: [
          { required: true, message: "*请输入现居住地址", trigger: "blur" }
        ],
        proxyName: [
          { required: true, message: "*请输入领取人姓名", trigger: "blur" }
        ],
        proxyCard: [
          { required: true, message: "*请输入领取人身份证号", trigger: "blur" },
          {
            pattern:
              "/^[1-9]d{5}(18|19|([23]d))d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)d{3}[0-9Xx]$/",
            message: "*您输入的格式不对",
            trigger: "blur"
          }
        ]
      },
      tableData: [
        {
          code: "",
          office: "",
          userRegisterName: "",
          fileSize: "",
          applier: "",
          receiptor: "",
          paperAmount: ""
        }
      ]
    };
  },
  created() {},
  mounted() {
    this.returnList = JSON.parse(sessionStorage.getItem("procedure"));
    console.log(this.returnList);
    this.resultData = this.returnList;
    this.notaryId = this.returnList.id;
    this.tableData[0].code = this.returnList.code;
    this.tableData[0].office = this.returnList.office;
    this.tableData[0].userRegisterName = this.returnList.userRegisterName;
    this.tableData[0].fileSize = this.returnList.fileSize;
    this.tableData[0].applier = this.returnList.applier;
    this.tableData[0].receiptor = this.returnList.receiptor;
    this.tableData[0].paperAmount = this.returnList.paperAmount;
    this.status = this.returnList.status;
    console.log(this.status);
    this.money = this.returnList.cost;
    this.Process(1);
    this.id = this.$route.query.id;
  },
  methods: {
    Process(num) {
      console.log(num);
      $(".message").removeClass("active");
      $(".message")
        .eq(num)
        .addClass("active");
    },
    closeDialog(data) {
      console.log(data);
      this.dialogVisible = data;
      this.successFul = data;
    },
    goPay() {
      this.dialogVisible = true;
    },
    notPay() {
      this.dialogVisible = false;
    },
    messageFn() {
      var params = {
        notaryServiceId: this.id
      };
      BaseApi.createRpcToken("/Judiciary/getNotarizationInfo", params)
        .then(
          data => {
            sessionStorage.setItem("procedure", JSON.stringify(data.datas));
            this.Process(3);
          },
          data => {
            console.log(data);
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    truePay() {
      var querStr = {
        businessType: "5",
        payType: 1,
        sourceFrom: "1",
        totalPrice: this.money,
        bussinessId: this.notaryId
      };
      console.log(querStr);
      BaseApi.createRpcToken("/pay/getPayNo", querStr, "post")
        .then(data => {
          console.log(data);
          if (data.code == "200") {
            this.dialogVisible = false;
            this.successFul = true;
            $("dl")
              .eq(3)
              .addClass("active");
            $(".message")
              .siblings()
              .removeClass("active");
            $(".message")
              .eq(3)
              .addClass("active");
            this.messageFn();
            setTimeout(() => {
              this.successFul = false;
            }, 2000);
          }
        })
        .catch(function(e) {
          errorLog(e);
        });
    },
    fileNumFn() {
      if (this.ruleForm.num == "") {
        this.fileNum = true;
      }
      if (/^([1-9][0-9]{0,1}|100)$/.test(this.ruleForm.num) == false) {
        this.fileNum = true;
      }
      setTimeout(() => {
        this.fileNum = false;
      }, 1000);
    }
  },
  components: {
    Dialog,
    BaseApi,
    waitPay,
    waitSub,
    waitAudit,
    finshed,
    waitReject,
    waitAccreditation,
    breadcrumb
  }
};
</script>

<style lang="scss">
.procedureBox {
  width: 100%;
  height: 100%;
  overflow: scroll;
  .procedureMain {
    padding: 20px;
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 3px;
    box-sizing: border-box;
  }
  .successFul {
    height: 200px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #646464;
  }
  .successFulBox {
    height: 200px;
    p:nth-child(1) {
      height: 150px;
      line-height: 150px;
      text-align: center;
      text-emphasis: center;
      span {
        font-size: 20px;
        color: #db4437;
      }
    }
    p:nth-child(2) {
      text-align: center;
      span {
        display: inline-block;
        width: 100px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        border: 1px solid #dcdcdc;
      }
      span:nth-child(1) {
        margin-right: 40px;
      }
      span:nth-child(2) {
        color: #fff;
        border-color: #db4437;
        background-color: #db4437;
      }
      span:nth-child(1):hover {
        color: #D81212;
        border-color: #D81212;
      }
      span:nth-child(2):hover {
        border-color: #D81212;
        background-color: #D81212;
      }
    }
  }
}
</style>

